var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFooterIconYoutube = function SvgFooterIconYoutube(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5506 11.7341C38.0188 12.1294 39.1765 13.2871 39.5718 14.7553C40.3059 17.4376 40.2776 23.0282 40.2776 23.0282C40.2776 23.0282 40.2776 28.5906 39.5718 31.2729C39.1765 32.7412 38.0188 33.8988 36.5506 34.2941C33.8682 35 23.1388 35 23.1388 35C23.1388 35 12.4376 35 9.72706 34.2659C8.25882 33.8706 7.10118 32.7129 6.70588 31.2447C6 28.5906 6 23 6 23C6 23 6 17.4376 6.70588 14.7553C7.10118 13.2871 8.28706 12.1012 9.72706 11.7059C12.4094 11 23.1388 11 23.1388 11C23.1388 11 33.8682 11 36.5506 11.7341ZM19.7227 17.8613L28.645 23.0002L19.7227 28.139V17.8613Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFooterIconYoutube);
export default ForwardRef;